module.exports = __webpack_public_path__ + "static/media/README.7eab72bb.md";